import { Button, dialog } from "nq-component";
import BasePage from "../../../../base/BasePage";
import CardView from "../../../../components/common/CardView";
import InputFactory from "../../../../components/InputFactory";
import SearchSelect from "../../../../components/searchSelect/SearchSelect";
import { findObjectUseCase } from "../../../../usecases/object";
import { FloatingForm } from "../../../../components/common/Converter";

export default class GenerateCOC extends BasePage {
  constructor(props) {
    super(props);
    this.state = {
      purpose: "",
      selectedEmployee: "",
      employee: [],
    };
  }

  async componentDidMount() {
    document.body.classList.add("modal-open");
    const employee = await findObjectUseCase().execute("employees");
    this.setState({ employee });
  }

  componentWillUnmount() {
    document.body.classList.remove("modal-open");
  }
  dialogClose() {
    dialog.close();
  }
  confirmChanges() {
    const { selectedEmployee, purpose } = this.state;
    const data = {
      employeeName: selectedEmployee,
      purpose,
    };

    console.warn("Generate: ", data);
    this.dialogClose();
    this.props.closeAccess();
    // this.showSuccess("Success");
    alert("Generate COC");
  }

  handleClickOk() {
    dialog.fire({
      html: (
        <div className="p-2">
          <div className="row">
            <h4>Submit Request Confirmation</h4>
            <hr />
            <p style={{ fontSize: "13px", padding: "1rem" }}>
              Click confirm to proceed.
            </p>
            <hr />
          </div>

          <div className="w-100 d-flex justify-content-end gap-4 pe-3 pb-3">
            <Button
              className="btn btn-light fs-sm"
              onClick={this.dialogClose.bind(this)}
            >
              Cancel
            </Button>
            <Button
              className="btn btn-primary"
              onClick={this.confirmChanges.bind(this)}
            >
              Confirm
            </Button>
          </div>
        </div>
      ),
      footer: false,
    });
  }

  handlePurpose(purpose) {
    this.setState({ purpose });
  }

  handleEmployeeChange(selectedEmployee) {
    this.setState({ selectedEmployee });
  }

  render() {
    return (
      <>
        <FloatingForm width="30rem">
          <CardView style={{ padding: 0 }}>
            <h4 className="fs-5 fw-bold pt-3 ps-3">Generate COC Certificate</h4>
            <hr />
            <form
              onSubmit={(e) => {
                e.preventDefault();
                this.handleClickOk();
              }}
            >
              <div className="w-100" style={{ padding: "0 1rem" }}>
                <div className="w-100">
                  <div className="p-2">
                    <div className="col-lg-12">
                      <label className="mb-2 fs-6">
                        Employee Name: <span className="text-danger">*</span>
                      </label>
                      <SearchSelect
                        required
                        value={this.state.selectedEmployee}
                        onChange={this.handleEmployeeChange.bind(this)}
                        options={this.state.employee.map((employee) => ({
                          label: `${employee.Firstname || ""} ${
                            employee.Middlename || ""
                          } ${employee.surname || ""}`,
                          value: `${employee.Firstname || ""} ${
                            employee.Middlename || ""
                          } ${employee.surname || ""}`,
                        }))}
                      />
                    </div>
                    <div className="col-lg-12">
                      <label className="mb-2 fs-6 mt-4">
                        Purpose: <span className="text-danger">*</span>
                      </label>
                      <InputFactory
                        required
                        type="textArea"
                        field="purpose"
                        // object={object}
                        placeholder="Write Purpose here..."
                        onChange={this.handlePurpose.bind(this)}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="w-100 d-flex justify-content-end gap-4 mb-3 pe-3">
                <Button
                  className="btn btn-light fs-sm"
                  onClick={() => this.props.closeAccess()}
                >
                  Cancel
                </Button>
                <Button className="btn btn-primary" type="submit">
                  Submit Request
                </Button>
              </div>
            </form>
          </CardView>
        </FloatingForm>
      </>
    );
  }
}
